import { render, staticRenderFns } from "./translation-in-iqube.vue?vue&type=template&id=4fa1f046&scoped=true&"
import script from "./translation-in-iqube.vue?vue&type=script&lang=ts&"
export * from "./translation-in-iqube.vue?vue&type=script&lang=ts&"
import style0 from "./translation-in-iqube.vue?vue&type=style&index=0&id=4fa1f046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1f046",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
